import { AppUtil } from './AppUtil'
import { JSBridgeUtil } from './JSBridgeUtil'

export enum DeviceState {
  Disconnected = 0,
  Connecting = 1,
  Connected = 2,
  Disconnecting = 3,
}

export interface IDeviceStatus {
  [index: string]: DeviceState
}

export interface JumpropeData {
  time: number
  count: number // 跳了多少次
  timingCount: number // 跳当前的个数，花了多少时间
  countDownTime: number // 跳绳倒计时
}

export function scan(cb?: (status: IDeviceStatus) => void) {
  if (cb) {
    AppUtil._addAppCallListener('scanSoSoJumpRopeResult', (data: string) => cb(parseData(data)))
  }

  JSBridgeUtil.asyncCall('scanSoSoJumpRope')

  if (!cb) {
    return new Promise((resolve) => {
      AppUtil._addAppCallListener('scanSoSoJumpRopeResult', resolve)
    })
  }
}

export function stopScan() {
  return JSBridgeUtil.asyncCall('stopScanSoSoJumpRope')
}

export function checkPower(cb?: (power: Record<string, number>) => void) {
  if (cb) {
    AppUtil._addAppCallListener('checkSoSoJumpRopePowerResult', (data: string) => cb(parseData(data)))
  }

  JSBridgeUtil.asyncCall('checkSoSoJumpRopePower')

  if (!cb) {
    return new Promise((resolve) => {
      AppUtil._addAppCallListener('checkSoSoJumpRopePowerResult', resolve)
    })
  }
}

export function startJumprope(seconds: number, cb?: (data: Record<string, JumpropeData>) => void) {
  if (cb) {
    AppUtil._addAppCallListener('jumpRopeData', (data: string) => cb(parseData(data)))
  }

  return JSBridgeUtil.asyncCall('startJumpRope', { time: seconds })
}

export function parseData(data: string) {
  try {
    return JSON.parse(data)
  } catch (e) {
    return
  }
}
